import { recordTrack } from '@saucelabs/sl-util-segmentio';
import { EVENT_CATEGORY } from '@saucelabs/sl-util-segmentio/lib/constants';

export const TRACKING_AREA = 'Automated';
export const TRACKING_SUB_AREA_DEFAULT = 'Archives';

export const ARCHIVES_EVENTS = Object.freeze({
  ARCHIVES_VIEWED: Object.freeze({
    category: EVENT_CATEGORY.PAGE_VIEWED,
    name: 'Navigate to Archives Page',
  }),
  ARCHIVES_CONTAINER_VIEWED: Object.freeze({
    category: EVENT_CATEGORY.PAGE_VIEWED,
    name: 'Navigate to Archives',
  }),
  SELECT_JOB: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Select Job',
  }),
  SELECT_ALL_JOBS: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Select All Jobs',
  }),
  SELECT_SHOW_COLUMNS_DROPDOWN: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Select Show Columns Dropdown',
  }),
  SELECT_SORT_BY_DROPDOWN: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Select Sort By Dropdown',
  }),
  SELECT_FAVORITE_SEARCH_BOX_BUTTON: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Select Favorite Search Box Button',
  }),
  SUBMIT_SEARCH_BOX_QUERY: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Submit Search Box Query',
  }),
  DELETE_JOB: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Delete Job',
  }),
  DELETE_SEARCH_BOX_QUERY: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Delete Saved Search Query',
  }),
  CHANGE_PAGE: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Select Page',
  }),
});

export const FILTER_EVENTS = Object.freeze({
  owner: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Select Owner Filter',
  }),
  status: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Select Status Filter',
  }),
  build: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Select Build Filter',
  }),
  os: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Select OS Filter',
  }),
  browser: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Select Browser Filter',
  }),
  date: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Select Date Filter',
  }),
  device: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Select Device Filter',
  }),
  tag: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Select Tag Filter',
  }),
  platform: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Select Platform Filter',
  }),
  teams: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Select Teams Filter',
  }),
});

export const trackEvent = ({ category, name, metadata }) => {
  recordTrack(category, {
    subject_name: name,
    ...metadata,
  });
};

/**
 * trackEventWrapper for trackEvent function
 * @param {object} metadata
 * @returns {function} a function that accepts event and eventPayload as arguments
 * @param {object} event
 * @param {object} eventPayload
 * @returns {undefined}
 */
export const trackEventWrapper = (metadata) => (event, eventPayload) => {
  trackEvent({
    ...event,
    metadata: {
      ...(typeof eventPayload === 'object' ? eventPayload : null),
      ...metadata,
    },
  });
};
